import React from "react";
import '../../styles/QuillProMinayla.css';
import { connect } from 'react-redux';
import ShipmentsTable from './ShipmentsTable'; // TODO table
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { getShipments, getDocuments, setReadyForPickUp } from '../../actions/ShipmentAction'; // TODO action
import InitialData from '../../components/InitialData';
class Shipment extends React.Component {
    state = {
        activeTab: 'Open',
        searchTerm: '',
        pageIndex: 0,
        maxRows: 25,
        isAllChecked: false,
        isOpenChecked: true,
        isHistoryChecked: false,
        isStrictTime: false,
        appointmentDate: '',
        dayPartId: '1',
        strictTime: '',
        deliveryContainerId: 0,
        refreshTable: false,
        refreshCount: 0
    }

    componentDidMount() {
        const { activeTab, maxRows, pageIndex, searchTerm } = this.state;
        const { getShipments, searchText } = this.props;
        getShipments(activeTab, pageIndex, maxRows, "");
    }

    allFiterFunc(Filtertype, searchTerm) {
        if (Filtertype === 'All') {
            this.setState({
                isAllChecked: true,
                isOpenChecked: false,
                isHistoryChecked: false,
                activeTab: 'All',
                searchTerm: searchTerm
            })
        }

        if (Filtertype === 'Open') {
            this.setState({
                isOpenChecked: true,
                isHistoryChecked: false,
                isAllChecked: false,
                activeTab: 'Open',
                searchTerm: searchTerm
            })
        }

        if (Filtertype === 'History') {
            this.setState({
                isOpenChecked: false,
                isHistoryChecked: true,
                isAllChecked: false,
                activeTab: 'History',
                searchTerm: searchTerm
            })
        }

        this.props.getShipments(Filtertype, searchTerm);
    }

    modalOpenButton = (deliveryContainerId, orderNumber) => {
        this.props.getDocuments(deliveryContainerId, orderNumber);
    }
    openReadyForPickUpButton = (deliveryContainerId) => {
        this.setState({ deliveryContainerId });
    }
    saveReadyForPickUp = () => {
        const { deliveryContainerId, appointmentDate, isStrictTime, strictTime } = this.state;
        const dayPartId = document.getElementsByName('daypartid')[0].checked ? "1" : "2";
        this.props.setReadyForPickUp({ deliveryContainerId, appointmentDate, dayPartId, isStrictTime, strictTime });
    }
    getDocumentPath = (path, docId) => {
        var storageType = path.substr(0, path.indexOf('_'));
        var apiUrl = 'app/api/v1/dispatching/retrievepod/' + docId;
        if (storageType === "ProofOfDelivery" || storageType === "POD") {
            apiUrl = "app/api/v1/dispatching/retrievepod/" + docId;
        } else if (storageType === "ContainerTicket") {
            apiUrl = "app/api/v1/dispatching/retrieveticket/" + docId;
        } else if (storageType === "WaitingTimeSignature") {
            apiUrl = "app/api/v1/dispatching/retrievewaitingtime/" + docId;
        } else if (storageType === "CustomerSignature") {
            apiUrl = "app/api/v1/dispatching/retrievecustomersignature/" + docId;
        } else if (storageType === "DriverSignature") {
            apiUrl = "app/api/v1/dispatching/retrievedriversignature/" + docId;
        } else if (storageType === "ContainerDoc") {
            apiUrl = "app/api/v1/dispatching/retrievecontainerdoc/" + docId;
        }
        return InitialData.minaylaUrl + apiUrl;
    }

    componentDidUpdate() {
        const { shipmentsTab, shipmentsPageIndex, getShipments, isLoading, showingMax, searchText } = this.props;
        let { activeTab, maxRows, pageIndex, searchTerm, refreshCount } = this.state;
        if (this.props.refreshTable && refreshCount === 0) {
            this.setState({ refreshCount: 1 });
            getShipments(activeTab, pageIndex, maxRows, searchTerm);
        } else if ((shipmentsTab !== activeTab ||
            pageIndex !== shipmentsPageIndex ||
            maxRows !== showingMax ||
            searchTerm !== searchText) &&
            !isLoading) {
            if (searchTerm !== searchText) {
                pageIndex = 1;
            }
            getShipments(activeTab, pageIndex, maxRows, searchTerm);
        }
    }

    onTabClick = tabName => {
        if (tabName !== this.state.activeTab) {
            this.setState({
                activeTab: tabName,
                pageIndex: 0
            });
        }
    };

    onSelectMaxRows = e => {
        const rows = e.target.value;

        if (this.state.maxRows !== rows) {
            this.setState({
                maxRows: rows,
                pageIndex: 0
            });
        }
    };

    render() {

        const { activeTab, maxRows, pageIndex, isAllChecked, isHistoryChecked, isOpenChecked, isStrictTime, refreshTable } = this.state;
        const { isLoading, counts, showingCount, orderNumber, documents } = this.props;

        let pages = 0;
        if (!isLoading && counts) {
            const count = counts[activeTab];
            pages = Math.trunc(count / maxRows) + (count % maxRows > 0 ? 1 : 0);
        }

        return (
            <main className="main-content d-flex justify-content-center" role="main">
                <div className="col-12">
                    {
                        <div className="row pt-2">
                            <div className="col-lg-10 offset-1 pb-5">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="input-group pull-left">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Quick search..."
                                                onChange={e => this.setState({ searchTerm: e.target.value })}
                                                value={this.state.searchTerm}
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary waves-effect waves-light icon-btn">
                                                    <FontAwesomeIcon icon={faSearch} size="lg" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3"></div>
                                    <div className="col-6">
                                        <div className="btn-group btn-group-toggle btn-group-custom-radio pull-right" data-toggle="buttons" >

                                            <button className={isOpenChecked ? 'btn btn-primary active' : 'btn btn-primary'} id="openRadio" onClick={() => this.allFiterFunc("Open", this.state.searchTerm)} >
                                                <input type="radio" name="options" id="option2" autoComplete="off" />OPEN
                                            </button>
                                            <button className={isHistoryChecked ? 'btn btn-primary active' : 'btn btn-primary'} id="historyRadio" onClick={() => this.allFiterFunc("History", this.state.searchTerm)} >
                                                <input type="radio" name="options" id="option3" autoComplete="off" />HISTORY
                                            </button>
                                            <button className={isAllChecked ? 'btn btn-primary active' : 'btn btn-primary'} id="allRadio" onClick={() => this.allFiterFunc("All", this.state.searchTerm)} >
                                                <input type="radio" name="options" id="option1" autoComplete="off" />ALL                                                    </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-10 offset-1">
                                <ShipmentsTable
                                    searchTermParent={this.state.searchTerm}
                                    activeTabParent={this.state.activeTab}
                                    pageIndexParent={this.state.pageIndex}
                                    openModal={this.modalOpenButton}
                                    openReadyForPickUpModal={this.openReadyForPickUpButton }
                                />
                                {
                                    (!isLoading && counts && pages > 0) ? (
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div><span>{`Showing ${showingCount} of ${counts[activeTab]} invoices`}</span></div>
                                            <div className="d-flex">
                                                {/* buttons show as ( [1] [2] [3] ) in the examples below */}
                                                {
                                                    // if this is the last page show second previous page button => ex.( show:[1] [2] current:[3] )
                                                    pageIndex + 1 === pages && pages >= 3 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex - 2 })}>{pageIndex - 1}</button>
                                                        : null
                                                }
                                                {
                                                    // if this is not the first page show previous page button => ex.( show:[1] current:[2] [3] )
                                                    pageIndex > 0 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex - 1 })}>{pageIndex}</button>
                                                        : null
                                                }

                                                {/* show the current page button => ex.( [1] show current:[2] [3] ) */}
                                                <button className="btn btn-info icon-btn mr-2">{pageIndex + 1}</button>

                                                {
                                                    // if there is more page after the current page show next page button => ex.( [1] current:[2] show:[3] )
                                                    pages > pageIndex + 1 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex + 1 })}>{pageIndex + 2}</button>
                                                        : null
                                                }
                                                {
                                                    // if this is the first page show second next page button => ex.( current:[1] [2] show:[3] )
                                                    pageIndex === 0 && pages >= pageIndex + 3 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex + 2 })}>{pageIndex + 3}</button>
                                                        : null
                                                }
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <span className="mr-2">Show</span>
                                                <select className="form-control" onChange={e => this.onSelectMaxRows(e)} value={maxRows} >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                        </div>
                    }
                </div>
                <div
                    className="modal fade"
                    id="shipmentModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5
                                    className="modal-title"
                                    id="exampleModalLabel"
                                >
                                    Document Viewer
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <h3 style={{ marginBottom: 30, marginLeft: 20 }}><strong># {orderNumber}</strong></h3>
                                <table className="table table-hover">
                                    <tbody>
                                        {
                                            documents ? documents.map((documents, key) =>
                                                <tr key={key}>
                                                    <th>{documents.documentId}</th>
                                                    <td>{documents.documentName}</td>
                                                    <td style={{ textAlign: "center" }}><a href={this.getDocumentPath(documents.documentName, documents.documentId)} target="blank">View <i className="batch-icon batch-icon-search"></i></a></td>
                                                </tr>
                                            ) : null
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="shipmentreadyForPickuP"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5
                                    className="modal-title"
                                    id="exampleModalLabel"
                                >
                                    Ready For PickUp
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label className="control-label">Appointment Date</label>
                                            <input type="date" className="placeholder form-control" id="scheduleDate"
                                                placeholder="__/__/____" autoComplete="off" required
                                                onChange={e => this.setState({ appointmentDate: e.target.value })}
                                                value={this.state.appointmentDate}
                                            ></input>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 pt-4">
                                        <div className="btn-group btn-group-toggle btn-group-custom-radio pull-left" data-toggle="buttons">
                                            <label className="btn btn-primary active">
                                                <input type="radio" name="daypartid" value="1"
                                                ></input> AM
                                            </label>
                                            <label className="btn btn-primary">
                                                <input type="radio" name="daypartid" value="2"
                                                ></input> PM
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 pt-4">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox"
                                                role="switch" aria-checked="true" id="isstricttime"
                                                onChange={e => this.setState({ isStrictTime: e.target.checked })}
                                                value={this.state.isStrictTime}
                                            ></input>
                                            <label className="form-check-label" htmlFor="isstricttime">Strict Time</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ display: isStrictTime ? 'flex' : 'none' }}>
                                    <div className="col-12 pt-4">
                                        <div className="form-group mb-3">
                                            <label htmlFor="hour-field">Hour</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="inputGroupPrepend-1">
                                                        <i className="batch-icon batch-icon-clock"></i>
                                                    </span>
                                                </div>
                                                <input type="text" className="time form-control" id="strictTime" placeholder="HH:mm" aria-describedby="inputGroupPrepend-1" required
                                                    onChange={e => this.setState({ strictTime: e.target.value })}
                                                    value={this.state.strictTime}
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button onClick={() => this.saveReadyForPickUp()} type="button" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {

    return {
        counts: state.shipmentData.counts,
        shipmentsTab: state.shipmentData.shipmentsTab,
        shipmentsPageIndex: state.shipmentData.shipmentsPageIndex,
        isLoading: state.shipmentData.isLoading,
        showingCount: state.shipmentData.list ? state.shipmentData.list.length : 0,
        showingMax: state.shipmentData.showingMax,
        searchText: state.shipmentData.searchText,
        documents: state.shipmentData.documents,
        orderNumber: state.shipmentData.orderNumber,
        isStrictTime: state.shipmentData.isStrictTime,
        refreshTable: state.shipmentData.refreshTable,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getShipments: (tab, pIndex, rows, searchTerm) => dispatch(getShipments(tab, pIndex, rows, searchTerm)),
        getDocuments: (deliveryContainerId, orderNumber) => dispatch(getDocuments(deliveryContainerId, orderNumber)),
        setReadyForPickUp: (state) => dispatch(setReadyForPickUp(state)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shipment);


// WEBPACK FOOTER //
// ./src/view/Shipment/Shipment.js